//send invitation
import CustomizedMenusIcon from "../../assets/invite-sharing.png";
import Invitetractingicon from "../../assets/invite-tracking.png";
import InvitesmartIcon from "../../assets/invite-smart.png";
import Invite from "../../assets/online-digital-invitation-maker.png";

//book priest
import PriestDemandIcon from "../../assets/priestdemanicon.png";
import DollarIcon from "../../assets/Dollaricon.png";
import DiscountIcon from "../../assets/Discounticon.png";
import ThumbIcon from "../../assets/thumbicon.png";
import InvitePriest from "../../assets/invite-priest.png";

//rent from tent
import VendorIcon from "../../assets/VendorIcon.png";
import DiningIcon from "../../assets/DiningtableIcon.png";
import CartIcon from "../../assets/CartIcon.png";
import PriceIcon from "../../assets/PriceIcon.png";
import Rentalhouses from "../../assets/tent-house-rental-services.png";

//ai event
import AiEvent from "../../assets/professional-event-management-services.png";
import { ReactComponent as AiMenuIcon } from "../../assets/CustomizedMenusIcon.svg";

//catering
import CATERING from "../../assets/online-catering-booking-service.png";
import VerifiedCaterersIcon from "../../assets/VerifiedCaterersIcon.svg";
import TransparentPriceIcon from "../../assets/transparentPriceIcon.svg";
import ReliableAvailableIcon from "../../assets/ReliableAvailableIcon.svg";
import ExclusiveDiscounts from "../../assets/ExclusiveDiscounts.svg";

export const offeringsData = {
  sendInvitation: {
    heading: "Why Choose Thurent Invitations?",
    subHeading: "for Smart Guest Management",
    image: Invite,
    alt: "Online digital invitation maker to create and manage invitation cards with RSVP",
    ABOUT_SECTION_TITLE: "Send Invitations Easily",
    ABOUT_SECTION_SUBTITLE: "and Manage Guests Smartly",
    ABOUT_SECTION_DESC: `
      Make your event unforgettable with Thurent's smart invitation system. 
      Create beautiful digital invites, share instantly via WhatsApp, track RSVPs in real-time, 
      and manage your guest list effortlessly. From small gatherings to grand celebrations, 
      our platform helps you reduce waste, optimize spending, and host perfectly.
    `,
    list: [
      {
        title: "Effortless Invitation Sharing",
        description: "Create and share beautiful digital invites instantly via WhatsApp and social media.",
        icon: <img src={CustomizedMenusIcon} alt="Icon" />,
      },
      {
        title: "Real-time RSVP Tracking",
        description: "Track guest responses instantly and get accurate headcount for better planning.",
        icon: <img src={Invitetractingicon} alt="Icon" />,
      },
      {
        title: "Smart Guest Insights",
        description: "Use attendee data to optimize your event budget and reduce food & logistics waste.",
        icon: <img src={InvitesmartIcon} alt="Icon" />,
      },
    ],
  },

  bookPriest: {
    heading: "Why Choose Thurent",
    subHeading: "for Pooja & Priest Services",
    image: InvitePriest,
    alt: "Instant pandit booking with fast confirmation for all religious ceremonies",
    ABOUT_SECTION_TITLE: "Book Pandit Online",
    ABOUT_SECTION_SUBTITLE: "for All Your Religious Ceremonies",
    ABOUT_SECTION_DESC: `
      Make every ritual sacred and stress-free with Thurent. Whether you need to book a pandit for weddings, 
      housewarming (Griha Pravesh), baby shower (God Bharai), havan, puja, or last rites (Antim Sanskar), 
      we connect you with experienced and verified priests. Find pandits near you or book online pandit services 
      for virtual puja ceremonies. We offer transparent pricing, trusted purohit services, and easy scheduling 
      to fulfill all your spiritual needs with care and precision.
    `,
    list: [
      {
        title: "Expert Priests On-Demand",
        description: "Connect with knowledgeable and experienced priests for all types of rituals and ceremonies.",
        icon: <img src={PriestDemandIcon} alt="Icon" />,
      },
      {
        title: "Fair & Transparent Pricing",
        description: "No hidden charges or unregulated fees—know exactly what you're paying upfront.",
        icon: <img src={DollarIcon} alt="Icon" />,
      },
      {
        title: "Always Available",
        description: "Find a priest even on short notice or when your regular pandit is unavailable.",
        icon: <img src={ThumbIcon} alt="Icon" />,
      },
      {
        title: "Special Discounts",
        description: "Get the best value for your religious ceremonies with exclusive offers.",
        icon: <img src={DiscountIcon} alt="Icon" />,
      },
    ],
  },

  rentFormTentHouse: {
    heading: "Why Choose Thurent",
    subHeading: "for Event Rentals",
    image: Rentalhouses,
    alt: "Online tent house booking service with complete event setup",
    ABOUT_SECTION_TITLE: "Rent from Tent Houses",
    ABOUT_SECTION_SUBTITLE: "and Simplify Your Event Planning",
    ABOUT_SECTION_DESC: `
      Planning an event? From intimate gatherings to grand celebrations, Thurent helps you rent 
      everything you need at the right price. Browse through trusted tent houses, compare prices, 
      and book quality rental items—all from the comfort of your home. Say goodbye to rental hassles 
      and focus on creating memorable events.
    `,
    list: [
      {
        title: "Wide Range of Rentals",
        description: "From furniture and decor to dinnerware and lighting—find everything for your event.",
        icon: <img src={DiningIcon} alt="Icon" />,
      },
      {
        title: "Trusted Local Vendors",
        description: "Connect with verified and reliable tent houses near you for quality rentals.",
        icon: <img src={VendorIcon} alt="Icon" />,
      },
      {
        title: "Transparent Pricing",
        description: "Compare costs upfront, see all charges clearly, and choose what fits your budget.",
        icon: <img src={PriceIcon} alt="Icon" />,
      },
      {
        title: "Convenient Booking",
        description: "Book everything you need online without visiting multiple shops or vendors.",
        icon: <img src={CartIcon} alt="Icon" />,
      },
    ],
  },

  aienabledevent: {
    heading: "AI-Powered Event Assistant",
    subHeading: "Your Smart Event Planning Guide",
    image: AiEvent,
    alt: "AI-enabled event planning, management, and vendor booking assistant",
    ABOUT_SECTION_TITLE: "Plan Smarter with AI",
    ABOUT_SECTION_SUBTITLE: "Your Personal Event To-Do List",
    ABOUT_SECTION_DESC: `
      Get intelligent suggestions and personalized to-do lists for your event. Our AI assistant helps you plan 
      every aspect of your celebration—from booking vendors to managing timelines. 
      
      Receive smart recommendations on:
      • When to book vendors (tent houses, caterers, priests)
      • What items you need based on your event type and guest count
      • Timeline checklists to ensure nothing is missed
      • Budget optimization tips
      
      Let AI handle the planning while you focus on enjoying your special day.
    `,
    list: [
      {
        title: "Smart Event Planning",
        description: "Get step-by-step AI-generated to-do lists and booking recommendations for your event.",
        icon: <AiMenuIcon />,
      },
    ],
  },

  bookcatering: {
    heading: "Why Choose Thurent",
    subHeading: "for Catering Services",
    image: CATERING,
    alt: "Book professional catering services for weddings, parties, and corporate events",
    ABOUT_SECTION_TITLE: "Book Catering Online",
    ABOUT_SECTION_SUBTITLE: "Delicious Food for Every Occasion",
    ABOUT_SECTION_DESC: `
      Make your event memorable with delicious food from top-rated caterers. Whether it's a wedding, 
      birthday party, corporate event, or family gathering, Thurent connects you with verified local caterers 
      who specialize in various cuisines. Browse menus, compare prices, read reviews, and book the perfect 
      catering service—all online. From vegetarian to non-vegetarian, traditional to contemporary, 
      find caterers who match your taste and budget.
    `,
    list: [
      {
        title: "Customized Menus",
        description: "Choose from vegetarian, non-vegetarian, or mixed menus tailored to your event needs.",
        icon: <img src={CustomizedMenusIcon} alt="Customized Menus" />,
      },
      {
        title: "Verified Local Caterers",
        description: "Work with trusted catering professionals who specialize in weddings, parties, and events.",
        icon: <img src={VerifiedCaterersIcon} alt="Verified Caterers" />,
      },
      {
        title: "Transparent Pricing",
        description: "Compare upfront per-plate costs and package prices to stay within your budget.",
        icon: <img src={TransparentPriceIcon} alt="Transparent Pricing" />,
      },
      {
        title: "Reliable Availability",
        description: "Find available caterers even when your regular provider is booked or unavailable.",
        icon: <img src={ReliableAvailableIcon} alt="Reliable Availability" />,
      },
      {
        title: "Exclusive Discounts",
        description: "Enjoy special savings and exclusive offers when booking through Thurent.",
        icon: <img src={ExclusiveDiscounts} alt="Exclusive Discounts" />,
      },
    ],
  },
};